<div style="padding:20px;height:400px;width:450px;display:block;">
  <div *ngFor="let obj of data.topStudents">
    <span style="display:block;margin-bottom:15px;font-size:25px;font-weight:bold;"> {{obj.score}} ✅ - {{obj.userName}} </span>
  </div>
</div>
